import { createFileRoute, redirect } from "@tanstack/react-router";
import { getTokenByVivaCode, getTokenByVivaTransaction } from "@/lib/orders.functions";

export const Route = createFileRoute("/payment/success")({
  validateSearch: (search: Record<string, unknown>) => ({
    s: typeof search.s === "string" || typeof search.s === "number" ? String(search.s) : undefined,
    t: typeof search.t === "string" || typeof search.t === "number" ? String(search.t) : undefined,
  }),
  loaderDeps: ({ search }) => ({ s: search.s, t: search.t }),
  loader: async ({ deps }) => {
    // Primary: resolve by Viva orderCode (?s=). Passing ?t= lets the reconciler
    // fall back to a transaction-level check when the orderCode lookup lags.
    if (deps.s) {
      const { token } = await getTokenByVivaCode({
        data: { code: deps.s, transactionId: deps.t },
      });
      if (token) throw redirect({ to: "/order/$token", params: { token } });
    }

    // Fallback: resolve by Viva transaction id (?t=). Reads merchantTrns from
    // Viva, which equals our order token — immune to orderCode precision loss.
    if (deps.t) {
      const { token } = await getTokenByVivaTransaction({ data: { transactionId: deps.t } });
      if (token) throw redirect({ to: "/order/$token", params: { token } });
    }
    throw redirect({ to: "/" });
  },
});